// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL;
const SUPABASE_PUBLISHABLE_KEY = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY;

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});

// Helper for consistency in logging Supabase events
export const logSupabaseEvent = (action: string, details: string, meta?: unknown) => {
  const timestamp = new Date().toLocaleTimeString();
  console.log(`%c[Supabase] ${action}`, 'color: #3ECF8E; font-weight: bold;', `[${timestamp}] ${details}`, meta || '');
};
